var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1017",
    "data-name": "Frame 1017",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1017_Background_Mask_",
    "data-name": "Frame 1017 (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#e6e8ec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_File_Upload_Line",
    "data-name": "icons/File Upload/Line",
    transform: "translate(13.95 14.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.99,19.894A3,3,0,0,1,.074,16.241L.8,12.98a3.99,3.99,0,0,1,1.076-1.96l9.848-9.848a4,4,0,0,1,5.656,0l1.344,1.343a4.007,4.007,0,0,1,0,5.657L8.875,18.02A4.006,4.006,0,0,1,6.914,19.1l-3.261.725A3.064,3.064,0,0,1,2.99,19.894Zm.268-7.429a2,2,0,0,0-.508.95l-.725,3.261A1,1,0,0,0,3,17.892a1.021,1.021,0,0,0,.222-.025l3.261-.724a2,2,0,0,0,.95-.508L3.258,12.465Zm7-7h0L4.672,11.05l4.172,4.172L14.43,9.636,10.258,5.465ZM14.551,2a1.987,1.987,0,0,0-1.414.586L11.672,4.05l4.172,4.172,1.464-1.464a2,2,0,0,0,0-2.829L15.965,2.586A1.987,1.987,0,0,0,14.551,2Z",
    transform: "translate(-0.001 0)",
    fill: "#777e90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9976fa2ddb238c47234145ed5925bad5.svg";
export { ForwardRef as ReactComponent };